import React, { useEffect, useState } from 'react'
import Styled from 'styled-components'

const GridResponse = ({ main, sub, className }) => {
    const [windowSize, setWindowSize] = useState(0)
    useEffect(() => {
        handleResize()
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    const handleResize = () => {
        const size = window.innerWidth
        setWindowSize(size)
    }

    return (
        <Container className={className}>
            <Main>{main}</Main>
            {windowSize > 1209 && <Side>{sub}</Side>}
        </Container>
    )
}

const Container = Styled.div`
    display: flex;
    width: 1190px;
    margin: 0 auto;

    @media (max-width: 1209px) {
        & {width: 950px}
    }
`
const Main = Styled.div`
    width: 950px;
`
const Side = Styled.div`
    margin: 0 0 0 20px;
    width: 220px;
`

export default GridResponse



// WEBPACK FOOTER //
// ./src/estimate_list/components/layout/grid_response.js